module.exports = __webpack_public_path__ + "static/media/avast-tesla-vince.a80d8e12.jpg";